import React, { useState } from 'react';
import { createSEProject } from '../../services/apiService';

const Se_project_creation = () => {
    const [formData, setFormData] = useState({
        project_name: '',
        project_description: '',
        e_commerce_page_link: '',
        marketing_video_link: '',
        marketing_image_link: '',
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [createdLink, setCreatedLink] = useState<string | null>(null);
    const [copied, setCopied] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await createSEProject(formData);

            if (response.status === 'success') {
                setCreatedLink(response.data.link);
                setFormData({
                    project_name: '',
                    project_description: '',
                    e_commerce_page_link: '',
                    marketing_video_link: '',
                    marketing_image_link: '',
                });
            }
        } catch (error) {
            console.error('Error creating project:', error);
            alert('Failed to create project.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const copyToClipboard = () => {
        if (createdLink) {
            navigator.clipboard.writeText(createdLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div className="kpi-scope max-w-2xl mx-auto p-6 bg-white rounded-xl shadow-md my-8 relative">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Create New Project</h2>

            <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Project Name</label>
                    <input
                        type="text"
                        name="project_name"
                        value={formData.project_name}
                        onChange={handleChange}
                        placeholder="Enter project name"
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Project Description</label>
                    <textarea
                        name="project_description"
                        rows={4}
                        value={formData.project_description}
                        onChange={handleChange}
                        placeholder="Write a brief summary of the project..."
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none resize-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">E-commerce Page Link</label>
                    <input
                        type="url"
                        name="e_commerce_page_link"
                        value={formData.e_commerce_page_link}
                        onChange={handleChange}
                        placeholder="https://example.com/store/product"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Marketing Video Link</label>
                    <input
                        type="url"
                        name="marketing_video_link"
                        value={formData.marketing_video_link}
                        onChange={handleChange}
                        placeholder="https://youtube.com/watch?v=..."
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Marketing Image Link</label>
                    <input
                        type="url"
                        name="marketing_image_link"
                        value={formData.marketing_image_link}
                        onChange={handleChange}
                        placeholder="https://example.com/assets/banner.png"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                </div>

                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2.5 px-4 rounded-lg shadow-sm transition disabled:bg-blue-300"
                >
                    {isSubmitting ? 'Creating...' : 'Create Project'}
                </button>
            </form>

            {/* Modal Popup */}
            {createdLink && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-xl max-w-md w-full p-6 shadow-2xl animate-fade-in">
                        <div className="text-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                                <span className="text-green-600 text-xl font-bold">✓</span>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Project Created Successfully!</h3>
                            <p className="text-sm text-gray-500 mb-4">Here is your dynamic experience link:</p>
                        </div>

                        <div className="flex items-center space-x-2 bg-gray-50 border border-gray-200 rounded-lg p-2.5 mb-6">
                            <input
                                type="text"
                                readOnly
                                value={createdLink}
                                className="w-full bg-transparent text-xs text-blue-600 outline-none font-mono truncate"
                            />
                            <button
                                onClick={copyToClipboard}
                                className="text-xs bg-blue-500 text-white px-3 py-1.5 rounded hover:bg-blue-600 transition whitespace-nowrap"
                            >
                                {copied ? 'Copied!' : 'Copy'}
                            </button>
                        </div>

                        <button
                            onClick={() => setCreatedLink(null)}
                            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 rounded-lg transition text-sm"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Se_project_creation;